"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paging = void 0;
const React = __importStar(require("react"));
const index_1 = require("../../index");
const Paging = (props) => {
    const { currentPage, totalPages } = props;
    const maxPagesShown = 7;
    const isCurrentPageFirstOrLast = (page, allPages) => {
        return page === 1 || page === allPages;
    };
    const getStartPageOfList = (current, total) => {
        if (current < 5) {
            // Starts at the first page if current is at the start of the list
            return 1;
        }
        else if (current > total - 4) {
            // If it's at the end of the list, it starts 5 pages after the last page
            return current - (4 - (total - current));
        }
        // Otherwise starts one before current
        return current - 1;
    };
    const getListOfPages = () => {
        const listOfPages = [];
        if (totalPages <= maxPagesShown) {
            for (let i = 1; i <= totalPages; i++) {
                listOfPages.push(i);
            }
        }
        else if (isCurrentPageFirstOrLast(currentPage, totalPages)) {
            listOfPages.push(1, 2, '...', totalPages - 1, totalPages);
        }
        else {
            const startPage = getStartPageOfList(props.currentPage, props.totalPages);
            // If there is two or more pages between startPage and one
            if (startPage > 3) {
                listOfPages.push(1, '...');
            }
            // Loops through 5 pages after startPage, also adds the rest if there is less than two pages to the last page
            for (let i = startPage; (i < startPage + 5 || totalPages - i < 2) && i < totalPages; i++) {
                listOfPages.push(i);
            }
            // Adds ellipsis if there is two or more pages between last page shown and totalPages
            if (listOfPages[listOfPages.length - 1] + 2 < totalPages) {
                listOfPages.push('...');
            }
            listOfPages.push(totalPages);
        }
        return listOfPages;
    };
    return (React.createElement("div", { className: "paging-container" },
        React.createElement("div", { className: `arrow-button arrow-button-left ${props.currentPage === 1 ? 'arrow-disabled' : ''}`, onClick: currentPage > 1 ? () => props.changePage(currentPage - 1) : undefined },
            React.createElement(index_1.Icon, { icon: "arrow_left_turquoise" })),
        getListOfPages().map((page, index) => {
            if (page === '...') {
                return (React.createElement("div", { key: index, className: "page-element page-ellipsis" }, page));
            }
            else {
                return (React.createElement("div", { key: index, className: `page-element page-button ${page === currentPage ? 'current-page-button' : ''}`, onClick: () => props.changePage(page) }, page));
            }
        }),
        React.createElement("div", { className: `arrow-button arrow-button-right ${props.currentPage === props.totalPages ? 'arrow-disabled' : ''}`, onClick: currentPage < totalPages ? () => props.changePage(currentPage + 1) : undefined },
            React.createElement(index_1.Icon, { icon: "arrow_right_turquoise" }))));
};
exports.Paging = Paging;
//# sourceMappingURL=Paging.js.map